$(document).on("DOMContentLoaded", function () {
  //turbolinks:load
  var homeSearchInputAutocompleteTimer;
  var isMobile = window.matchMedia(
    "only screen and (max-width: 576px)"
  ).matches;

  // inmplement autocomplete for search input
  // SEARCH BOX AND AUTOCOMPLTE HANDLING
  // -----------------

  var loadingSuggestions = false;

  const enableSearchInput = () => {
    $(".location-search-input").prop("disabled", false);
    $(".location-search-input-wrapper").removeClass("disabled");
    $(".location-search-input").prop("errored");
  };

  const disableSearchInput = () => {
    $(".location-search-input").blur();
    $(".location-search-input").prop("disabled", true);
    $(".location-search-input-wrapper").addClass("disabled");
  };

  const showLocationSharingErrorInInput = () => {
    $(".location-search-input").addClass("errored");
    $(".location-search-input").attr(
      "placeholder",
      I18n.t("js.location_sharing.error_input_placeholder")
    );
  };

  const handleLocationSharingError = (e) => {
    enableSearchInput();
    if (e.code === e.TIMEOUT) {
      alert(I18n.t("js.location_sharing.error_timeout"));
    } else {
      if (isMobile) alert(I18n.t("js.location_sharing.error_disabled"));
      showLocationSharingErrorInInput();
    }
  };

  const submitLocationUrl = (url) => {
    disableSearchInput();

    // HANDLE THIS VIA ..https://gist.github.com/varmais/74586ec1854fe288d393
    if (url === "GPS") {
      if (navigator.geolocation) {
        requestBrowserGPSPosition()
          .then((position) => {
            window.location.assign(
              `/${I18n.locale}/${I18n.t("routes.search-by-gps")}?lat=${
                position.coords.latitude
              }&lng=${position.coords.longitude}`
            ); //Turbolinks.visit
          })
          .catch((e) => handleLocationSharingError(e));
        return;
      } else {
        enableSearchInput();
        alert(I18n.t("js.location_sharing.error_not_available"));
        if (isMobile) showLocationSharingErrorInInput();
        return;
      }
    }

    //if not GPS just visit location page
    window.location.assign(url); //Turbolinks.visit
  };

  const requestBrowserGPSPosition = () => {
    if ("geolocation" in navigator) {
      //check geolocation available
      //try to get user current location using getCurrentPosition() method
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        });
      });
    } else {
      return Promise.reject;
    }
  };

  // enable inputs (if we come back from search page)
  $(".location-search-input").prop("disabled", false);
  $(".location-search-input-wrapper").removeClass("disabled");

  const loadSuggestions = (input) => {
    $.get(
      `/${I18n.locale}/locations-autocomplete?q=${encodeURI($(input).val())}`,
      (html) => {
        loadingSuggestions = false;
        $(".location-search-suggestions-container").html(html);
      }
    );
  };

  //AJAXload with delay for fast tiping
  $(".location-search-input").on("keyup", (e) => {
    if ((e.keyCode >= 37 && e.keyCode <= 40) || e.keyCode == 13) return; //arrow keys or enter

    const input = $(e.currentTarget);
    clearTimeout(homeSearchInputAutocompleteTimer);
    loadingSuggestions = true;
    homeSearchInputAutocompleteTimer = setTimeout(function () {
      loadSuggestions(input);
    }, 200);
  });

  $(".location-search-input").on("focus", (e) => {
    loadSuggestions(e.currentTarget);
    $(".location-search-suggestions-container").show();
    $(".location-search-input").removeClass("errored not-yet-focused");
    $(".location-search-input").attr(
      //navbar search has location as placeholder at first, we replace it on focus
      "placeholder",
      I18n.t(`pages.home_header.search_placeholder.${ENV.tld}`)
    );
    if (isMobile) {
      //on Mobile scroll to top so the suggestions list is visible
      window.scrollTo(
        null,
        window.scrollY + e.currentTarget.getBoundingClientRect().top - 40 // -10
      );
    }
  });

  $(".location-search-input").on("blur", () => {
    $(".location-search-suggestions-container").hide();
  });

  //handle arrow keys navigation of suggestion list
  $(".location-search-input").on("keydown", (e) => {
    $(".location-search-suggestions-container").show(); //we also show on key for slow connections when javascript is not loaded yet when they focus input

    const selectedLiIndex = $(
      ".location-search-suggestions-container li.selectable.selected"
    ).index(".selectable");
    const list = $(".location-search-suggestions-container li.selectable");

    //down arrow
    if (e.keyCode === 40) {
      if (selectedLiIndex >= 0 && selectedLiIndex < list.length - 1) {
        $(list[selectedLiIndex]).removeClass("selected");
        $(list[selectedLiIndex + 1]).addClass("selected");
      } else {
        //select first .selectable
        list.first().addClass("selected");
        if (selectedLiIndex > 0)
          //remove select if moving from last item
          $(list[selectedLiIndex]).removeClass("selected");
      }
      return false;
    } else if (e.keyCode === 38) {
      //up arrow
      if (selectedLiIndex >= 1) {
        $(list[selectedLiIndex]).removeClass("selected");
        $(list[selectedLiIndex - 1]).addClass("selected");
      } else {
        //select first .selectable
        list.last().addClass("selected");
        if (selectedLiIndex === 0)
          $(list[selectedLiIndex]).removeClass("selected");
      }

      return false;
    } else if (e.keyCode === 13) {
      if (loadingSuggestions === true) return false;
      //enter
      handleSubmitPressed();
      return false;
    } else if (e.keyCode === 8) {
      // BackSpace
      $(".location-search-input").removeClass("errored");
    }
  });

  function handleSubmitPressed() {
    const selectedLi = $(
      ".location-search-suggestions-container li.selectable.selected"
    ).first();
    if (selectedLi.length !== 0) {
      submitLocationUrl(selectedLi.data("url"));
    } else {
      $(".location-search-input").addClass("errored");
    }
  }

  $(".location-search-input-wrapper").on(
    "touchstart mousedown", //mousedown is before blur, it dint worked with click
    ".location-search-submit-button",
    () => {
      handleSubmitPressed();
    }
  );

  // highlight suggestion when mouse is over it
  $(".location-search-suggestions-container").on(
    "mouseover",
    "li.selectable",
    (e) => {
      const me = $(e.currentTarget);
      if (me.hasClass("selected")) return;

      const selectedLi = $(
        ".location-search-suggestions-container li.selectable.selected"
      ).first();

      me.addClass("selected");
      selectedLi.removeClass("selected");
    }
  );

  $(".location-search-suggestions-container").on(
    "mousedown",
    "li.selectable",
    (e) => {
      e.preventDefault(); //keep focus on input so the select is not hidden
    }
  );

  // submit on suggestion click
  $(".location-search-suggestions-container").on(
    "click",
    "li.selectable",
    (e) => {
      //delegate ON
      const me = $(e.currentTarget);
      submitLocationUrl(me.data("url"));
    }
  );

  if (isMobile) {
    //make search input 100% on mobile (hide items around on focus)
    $("#navbar-search-input").on("focus", () => {
      $(".navbar .navbar-hideable").hide();
    });
    $("#navbar-search-input").on("blur", () => {
      $(".navbar .navbar-hideable").show();
    });
  }
});
